import React from "react";

import HeaderStyles from "./Header.module.scss";

import Menu from "../Menu/Menu";

const Header = ({
  scrollToHome,
  scrollToPortfolio,
  scrollToAboutMe,
  scrollToContact,
}) => {
  return (
    <div className={HeaderStyles.container}>
      <div className={HeaderStyles.name}>
        {"//"} Jonghoa{" "}
        <b>
          {"{"} CHONG {"}"}
        </b>
      </div>
      <Menu
        scrollToHome={scrollToHome}
        scrollToPortfolio={scrollToPortfolio}
        scrollToAboutMe={scrollToAboutMe}
        scrollToContact={scrollToContact}
      />
    </div>
  );
};

export default Header;
